import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { 
    Dialog, DialogTitle, DialogContent, Box, 
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CustomInputPassword from '../common/CustomInputPassword';
import CustomInput from '../common/CustomInput';
import CustomButton from '../common/CustomButton';
import useGlobalMutation from '../../hooks/useGlobalMutation';
import { impersonateLoginApi } from '../../api/AuthApi'; 
import { impersonateUser } from '../../helpers/auth';
import { useToast } from '../../hooks/ToastProvider';
import passwordSchema from '../../yups/passwordSchema';

const ImpersonationDialog = ({ open, onClose }) => {
    const { showToast } = useToast();
    
    const { control, handleSubmit, reset } = useForm({
        defaultValues: { targetId: '', adminId: '', password: '' },
        resolver: yupResolver(passwordSchema)
    });

    const mutation = useGlobalMutation(impersonateLoginApi, {
        onSuccess: (res) => {
            impersonateUser({
                targetId: res.data.targetId,
                token: res.data.token
            });
            onClose();
            reset();
        },
        onError: (e) => {
            showToast(e.message || 'ログインに失敗しました');
        }
    });

    const onSubmit = handleSubmit((data) => {
        mutation.mutate(data);
    });

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="xs" 
            fullWidth
            PaperProps={{ sx: { borderRadius: 2 } }}
        >
            <DialogTitle sx={{ 
                m: 0, p: 2, fontWeight: 700, textAlign: 'center', fontSize: '1.1rem',
                borderBottom: '1px solid #eee' 
            }}>
                代理ログイン
                <IconButton
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ padding: '16px !important', mt: 1 }}>
                <form onSubmit={onSubmit}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                        <CustomInput 
                            control={control} 
                            name="targetId" 
                            placeholder="需要家のログインID" 
                        />
                        <CustomInput 
                            control={control} 
                            name="adminId" 
                            placeholder="ご自身のログインID" 
                        />
                        <CustomInputPassword 
                            control={control} 
                            name="password" 
                            placeholder="ご自身のパスワード" 
                        />

                        <CustomButton
                            type="submit"
                            loading={mutation.isLoading}
                            sx={{
                                mt: 2,
                                backgroundColor: '#1a4f99',
                                color: '#ffffff',
                                borderRadius: 1,
                                padding: '12px',
                                fontSize: '16px',
                                fontWeight: 700,
                                textTransform: 'none',
                                '&:hover': { backgroundColor: '#1e3a63' }
                            }}
                        >
                            代理ログインする
                        </CustomButton>

                        <CustomButton
                            onClick={onClose}
                            variant="outlined"
                            sx={{
                                color: 'rgba(0, 0, 0, 0.6)',
                                borderColor: '#ccc',
                                borderRadius: 1,
                                padding: '12px',
                                fontSize: '16px',
                                fontWeight: 700,
                                textTransform: 'none',
                                '&:hover': { borderColor: '#999', backgroundColor: 'transparent' }
                            }}
                        >
                            閉じる
                        </CustomButton>
                    </Box>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default ImpersonationDialog;
